document.addEventListener('DOMContentLoaded', function() {
    const complaintDetails = JSON.parse(localStorage.getItem('complaintDetails'));
    const complaintDetailsList = document.getElementById('complaint-details-list');
    const tableBody = complaintDetailsList.querySelector('table > tbody');
    
    if (complaintDetails && complaintDetails.callList && complaintDetails.callList.length > 0) {
        complaintDetails.callList.forEach(complaint => {
            const row = document.createElement('tr');
            row.innerHTML = `
                <td>${complaint.callId}</td>
                <td>${complaint.mobileNumber}</td>
                <td>${complaint.customerName}</td>
                <td>${complaint.callStatusDescription}</td>
            `;
            tableBody.appendChild(row);
        });
    } else {
        complaintDetailsList.textContent = 'No data found';
    }
});
